export default "__VITE_ASSET__CFrQKHJs__"